import DefaultTheme from './default';

const currentTheme = new DefaultTheme();
export const getBaseTheme = () => currentTheme.getBaseTheme();
